import lmAddCommas from "./lmAddCommas";
import lmIsEmail from "./lmIsEmail";
import lmParse from "./lmParse";

const mlsFormatDetail = ( value: string | number ): React.ReactElement | string => {
    switch ( typeof value ) {
        case 'number':
            return value.toString();
        case 'string':
        default:
            if ( lmIsEmail( value ) ) {
                return lmParse( '<CTA url="mailto:' + value + '" text="' + value + '" target="_blank" class="mls-email" />' );
            } else {
                return lmParse( value.length && value !== '0' ? value : '---' );
            }
    }
    
}
export default mlsFormatDetail;